<!--  -->
<template>
  <div class="yunDetail">
    <!-- 导航（面包屑） -->
    <div class="nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <span class="el-icon-s-home"></span>
          <a href="/">首页</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a href="/cement/index.html#/CloudShow">云展厅</a>
        </el-breadcrumb-item>
        <!-- <el-breadcrumb-item><a href="/CloudShow#/CloudShow">云路演</a></el-breadcrumb-item> -->
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="top">
      <div class="videoContainer">
        <video id="video" controls :src="videoUrl"></video>
      </div>
      <div class="videoTitle">
        <h3>{{ info.Title }}</h3>

        <el-popover placement="left-start" width="200" trigger="click">
          <div class="qrcodeBox" ref="qrcodeBox">
            <div id="qrcode"></div>
            <p>请使用微信扫描二维码</p>
          </div>

          <el-button slot="reference" type="text">
            <p>
              <span @click="showecode">
                <img src="../../assets/Home/分享 (1).png" alt />
                分享至手机
              </span>
            </p>
          </el-button>
        </el-popover>

        <p>
          <span id="copylink" @click="copylink">
            <img src="../../assets/Home/KHCFDC_复制.png" alt />
            复制分享链接
          </span>
        </p>
      </div>
      <div>
        <ul class="descInf">
          <li>单位名称：{{ info.CompanyOrPersonName }}</li>
          <li>技术领域：{{ key.substring(0, key.length - 1) }}</li>
          <!-- <li>拟投资金额：{{ info.InvestInFunds }}万元</li> -->
          <li>拟投资金额：{{ info.InvestMoney=="0"?"面议":info.InvestMoney +"万元" }}</li>
          <!-- <li>合作方式：{{ key1.substring(0, key1.length - 1) }}</li> -->
          <li>合作方式：{{ info.Coopera }}</li>
          <div class="btn">
            <el-button type="primary" @click="Docking">
              <img src="../../assets/Home/分组 39@2x.png" alt style="width: 20px" />
              我要对接
            </el-button>
          </div>
        </ul>
      </div>
    </div>

    <div class="container">
      <el-tabs type="border-card" :stretch="true">
        <el-tab-pane label="项目详情" v-html="info.Content"></el-tab-pane>
        <el-tab-pane label="对接动态">
          <!-- 暂无数据 -->
          <empty v-if="showEmpty"></empty>
          <!-- 有数据 -->
          <div class="DockingList" v-else>
            <div class="msgContent" v-for="(item, index) in msgList" :key="item.ID">
              <div class="lis">
                <div class="LeftInfo">
                  <img src="../../assets/Home/组 4218.png" alt style="width: 3.625rem" />
                  <div class="Left-R">
                    <p class="pname">{{ item.UserName }}</p>
                    <p class="p-border">{{ item.Content }}</p>
                  </div>
                </div>
                <div class="RightTime">{{ item.Create_time }}</div>
              </div>
              <!-- 点赞评论，回复 -->
              <ul class="commentList">
                <li v-for="(i, n) in coo[index]">
                  <p>
                    <span class="commentName">{{ i.RealName }} ：</span>
                    <span class="commentText">{{ i.Content }}</span>
                  </p>
                  <p class="commentTime">{{ i.createtime.substring(0, 10) }}</p>
                </li>
              </ul>
              <div class="islike">
                <p class="comment" @click="comment(item.ID)">
                  <img src="../../assets/images/组 24783@2x.png" alt />
                  <span>评论</span>
                </p>
                <!-- 点赞状态 -->
                <p v-if="item.Is == 'Y'" @click="liked(item, index)" class="goodjob">
                  <img src="../../assets/images/组 247866@2x.png" alt />
                  <span>{{ item.r }}</span>
                </p>
                <!-- 未点赞状态 -->
                <p v-else class="goodjob" @click="liked(item, index)">
                  <img src="../../assets/images/组 24786@2x.png" alt />
                  <span>{{ item.r }}</span>
                </p>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 我要对接的弹框 -->
    <Docking
      v-if="DialogVisible"
      :DialogVisible.sync="DialogVisible"
      :id="id.toString()"
      :type="LeaveType"
      :ParentId="ParentId"
    ></Docking>
  </div>
</template>

<script>
import { roldList, imgcommonUrl, dockingList, Docking1 } from '../../api/url'
import { postAction, getAction } from '../../api/api'
import Docking from '@/components/Docking.vue'
import empty from '../../components/empty.vue'
//生成二维码
import QRCode from 'qrcodejs2'
import Clipboard from 'clipboard'

export default {
  components: { Docking, empty },
  data() {
    return {
      DId: '',
      AId: '',
      type: '',
      info: '',
      videoUrl: '',
      DialogVisible: false,

      LeaveType: '',
      showEmpty: false,
      DockingList: [],
      key: '',
      key1: '',
      id: '',
      ytype: '',
      msgList: [],
      ParentId: 0,
      shatwon: [],
      coo: [],
    }
  },
  computed: {},
  mounted() {
    let that = this
    // //// console.log("idid",id)
    var isCopy = new Clipboard('#copylink', {
      text: function () {
        let id = that.ID1
        //// console.log(id);
        // 待更正
        // return 'http://localhost:10001/#' +'/demandDialogCopy'+ '?id='+ id;
        return window.location.href
      },
    })
    isCopy.on('success', function (e) {
      //// console.log(e);
    })
    // //登录成功
    // this.$bus.$on("LoginSuccess", (e) => {
    //   // //// console.log(e);
    //   if (e) {
    //     setTimeout(()=>{
    //       this.UserID=localStorage.getItem("RealID")
    //       this.loadDemandDialog();
    //       //// console.log("eeee是否收藏",localStorage.getItem("RealID"))},400)
    //   }
    // });
  },
  watch: {},
  methods: {
    // 云路演详情页
    yunDetail() {
      if (this.type == '1') {
        this.id = this.DId
        this.ytype = 3
        //// console.log("111", this.id);
      } else {
        this.id = this.AId
        this.ytype = 4
        //// console.log("222", this.id);
      }
      let data = {
        action: 'Get_RoadShowById',
        id: this.id,
        type: this.type,
        UserID: '',
      }
      postAction(roldList, this.$qs.stringify(data)).then((res) => {
        //// console.log("云路演详情1111111", res);
        this.info = res
        //// console.log("云路演详情页视频播放地址", res.videoUrl);
        // this.videoUrl = imgcommonUrl + res.videoUrl;
        this.videoUrl = res.videoUrl
        let key = res.TechFieldEnum
        let key1 = res.Coopera
        // //// console.log(key)
        //// console.log("合作方式rrrrrrrrrrr", key1);

        let data = ''
        if (key.indexOf('5') !== -1) {
          data += '新一代信息技术,'
        }
        if (key.indexOf('7') !== -1) {
          data += '高端装备制造,'
        }
        if (key.indexOf('10') !== -1) {
          data += '新型材料,'
        }
        if (key.indexOf('11') !== -1) {
          data += '新能源及新能源汽车,'
        }
        if (key.indexOf('13') !== -1) {
          data += '现代农业,'
        }
        if (key.indexOf('14') !== -1) {
          data += '食品工业,'
        }
        if (key.indexOf('9') !== -1) {
          data += '生物医药及健康,'
        }
        if (key.indexOf('8') !== -1) {
          data += '节能环保,'
        }
        if (key.indexOf('15') !== -1) {
          data += '公共安全和应急处置,'
        }
        if (key.indexOf('16') !== -1) {
          data += '其他,'
        }
        this.key = data
        // 合作方式
        // //// console.log(this.key)
        let data1 = ''
        // if (key1.indexOf("21") !== -1) {
        //   data1 += "股权投资,";
        // }
        // if (key1.indexOf("22") !== -1) {
        //   data1 += "技术转让,";
        // }
        // if (key1.indexOf("23") !== -1) {
        //   data1 += "许可使用,";
        // }
        // if (key1.indexOf("24") !== -1) {
        //   data1 += "合作开发,";
        // }
        // if (key1.indexOf("25") !== -1) {
        //   data1 += "合作新办新企业,";
        // }
        // if (key1.indexOf("26") !== -1) {
        //   data1 += "其他,";
        // }
        // this.key1 = data1;
      })
      // .catch(() => {
      //   //// console.log("请求失败");
      // });
    },
    // 我要对接（先判断是否登录）
    Docking() {
      let RealName = localStorage.getItem('RealName')
      let vm = this
      if (this.type == '1') {
        this.id = this.DId
        this.LeaveType = '7'

        //// console.log("111", this.id);
      } else {
        this.id = this.AId
        this.LeaveType = '6'

        //// console.log("222", this.id);
      }
      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.DialogVisible = true
        //// console.log("云路演详情我要对接的projectid",this.id)
        // //// console.log("点击了yunDetail我要对接")
        // //// console.log('this.DialogVisible',this.DialogVisible)
      }
    },

    // 加载留言对接列表
    // loadDockingList() {
    //   if (this.type == "1") {
    //     this.id = this.DId;
    //     //// console.log("111", this.id);
    //   } else {
    //     this.id = this.AId;
    //     //// console.log("222", this.id);
    //   }
    //   this.UserID = localStorage.getItem("RealID");
    //   let data = {
    //     action: "Get_TechFieldList",
    //     sort: "DESC",
    //     uid: this.UserID,
    //     projId: this.id,
    //   };
    //   postAction(dockingList, this.$qs.stringify(data)).then((res) => {
    //     //// console.log("对接列表返回的1", res);
    //     this.DockingList = res;
    //     if (res.length == 0) {
    //       this.showEmpty = true;
    //     } else {
    //       this.showEmpty = false;
    //     }
    //   });
    // },
    //获取对接列表
    getMessage() {
      if (this.type == '1') {
        this.id = this.DId
        this.LeaveType = '7'

        //// console.log("111", this.id);
      } else {
        this.id = this.AId
        this.LeaveType = '6'

        //// console.log("222", this.id);
      }
      let data = {
        action: 'UserLeaveList',
        UserID: localStorage.getItem('userId'),
        // UserID:1,
        projectid: this.id,
        // projectid: 74497,
        type: this.LeaveType,
        pageIndex: '1',
        pageSize: '10',
        // ParentId:'0',
        ParentId: 0,
      }
      getAction(Docking1, data).then((res) => {
        //// console.log(res);
        this.msgList = res.list
        if (res.list.length == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        res.list.forEach((item, index) => {
          if (item.r == null) {
            item.r = 0
          }
          let b = {
            action: 'UserLeaveList',
            pageIndex: 1,
            pageSize: '',
            projectid: this.id,
            // projectid: 74497,
            type: this.LeaveType,
          }
          b.ParentId = item.ID

          ////// console.log(b);
          getAction(Docking1, b).then((res) => {
            //// console.log("评论内容", res);
            this.shatwon = res.list

            if (this.coo.length == index) {
              this.coo.push(this.shatwon)
            }
          })
        })
      })
    },

    // 点赞
    liked(a, index) {
      let RealName = localStorage.getItem('RealName')
      //// console.log("RealName", RealName);

      if (RealName == '' || RealName == null) {
        let vm = this
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        //// console.log(a);
        // this.islikeflag = !this.islikeflag;
        // //// console.log(this.islikeflag)
        let data = {
          action: 'Support',
          userid: localStorage.getItem('userId'),
          // userid:1,
          projectid: a.ID,
        }
        postAction(Docking1, this.$qs.stringify(data)).then((res) => {
          //// console.log(res);
          let data = {
            action: 'UserLeaveList',
            UserID: localStorage.getItem('userId'),
            // UserID:1,
            projectid: this.id,
            // projectid: 74497,
            type: this.LeaveType,
            pageIndex: '1',
            pageSize: '10',
            // ParentId:'0',
            ParentId: 0,
          }
          getAction(Docking1, data).then((res) => {
            //// console.log(res);
            //// console.log(index);
            if (this.msgList[index].Is == 'Y') {
              this.msgList[index].r -= 1
            } else {
              this.msgList[index].r += 1
            }

            this.msgList[index].Is = res.list[index].Is
          })
        })
      }
    },
    //评论
    comment(a) {
      //// console.log(a); //列表的ID
      this.ParentId = Number(a)

      let RealName = localStorage.getItem('RealName')
      let vm = this

      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.DialogVisible = true
        //// console.log("需求详情我要对接的ProjectID", this.ProjectID);
        // //// console.log("点击了yunDetail我要对接")
        // //// console.log('this.DialogVisible',this.dDialogVisible)
      }
    },
    // 分享至手机
    showecode() {
      //// console.log("分享至手机");
      this.getCoed()
    },
    getCoed() {
      //// console.log("生成二维码");
      document.getElementById('qrcode').innerHTML = ''
      let qrcode = new QRCode('qrcode', {
        width: 180, // 宽
        height: 180, // 高
        // text: "http://localhost:9999/#/SharePage?type="+this.ytype+'&id='+this.id, // 二维码内容,也可以直接放接口获取的数据
        text:
          imgcommonUrl +
          '/cement/index.html#/SharePage?type=' +
          this.ytype +
          '&id=' +
          this.id, // 二维码内容,也可以直接放接口获取的数据
        render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      })
      //// console.log(qrcode);
    },
    // 复制链接
    // 复制分享链接
    copylink() {
      // //// console.log(window.location.href);
      this.$message({
        message: '已复制分享链接',
        customClass: 'messageBox',
        // duration: 0,
        iconClass: '0',
      })
    },
  },
  created() {
    //// console.log(this.$route.query);
    this.DId = this.$route.query.dID
    this.AId = this.$route.query.aID
    this.type = this.$route.query.type
    //// console.log("this.$route.query.type", this.$route.query.type);
    setTimeout(() => {
      this.yunDetail()
    }, 200)

    // 获取用户id
    this.UserID = localStorage.getItem('RealID')
    // 加载留言对接列表
    this.getMessage()
  },
}
</script>
<style lang="scss" scoped>
.yunDetail {
  font-size: 1rem;
  width: 80rem;
  text-align: center;
  background: #fff;
  padding-bottom: 3.125rem;
  margin: 0 auto;
  font-family: Microsoft YaHei;
  .nav {
    margin-top: 35px;
    margin-bottom: 20px;
  }
  #video {
    width: 100%;
    height: 100%;
  }

  .top {
    height: 46.375rem;
    background: #fff;
    box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.06);
    padding: 1.875rem;
  }

  .videoContainer {
    width: 76.25rem;
    height: 38.25rem;
  }

  .videoTitle {
    position: relative;
    display: flex;
    margin-top: 1.875rem;
    height: 3.1875rem;
    /* line-height: 1; */
    color: #0a0a0a;
    vertical-align: middle;
    font-family: Microsoft YaHei;
    justify-content: space-between;
    /deep/.el-button--text {
      position: absolute;
      top: 0.15rem;
      right: 11.25rem;
      color: #2769dc;
      font-size: 1rem;
      padding: 0 1.25rem;
    }
    img {
      vertical-align: middle;
    }
  }

  .videoTitle > h3 {
    font-size: 2rem;
    font-weight: bold;
  }
  .videoTitle > p {
    float: right;
    margin-right: -2.1875rem;
    color: #2769dc;
    cursor: pointer;
  }
  .videoTitle > p > span {
    margin-right: 2.875rem;
    img {
      vertical-align: middle;
    }
  }
  .descInf {
    position: relative;
    height: 2.125rem;
    text-align: left;
    margin: 1.25rem 0;
    /* margin: 1.7rem 0; */
  }

  .descInf > Li {
    display: inline-block;
    font-size: 1rem;
    color: #999;
    margin-right: 2.5rem;
  }
  #pane-0 {
    text-align: left;
  }

  /deep/.el-tabs--border-card > .el-tabs__content {
    /* font-size: 1.5rem; */
    padding: 0.625rem 2.5rem 3rem 2.5rem;
  }

  .btn {
    position: absolute;
    top: 0;
    right: 0;
    margin-left: 0.625rem;
    /* float: right; */
    /deep/.el-button {
      padding: 0;
    }
    .el-button--primary {
      margin-top: -1.586667rem;
      border-color: #2769dc;
      background: #2769dc;

      height: 2.8125rem;
      width: 7.9375rem;
      font-size: 1.225rem;

      img {
        vertical-align: middle;
      }
    }
  }
  /deep/.el-tabs__item {
    font-size: 1.5rem;
    /* color: #333333 !important; */
  }
  /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #333333;
  }
  /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #2769dc;
    color: #2769dc;
    font-size: 1.5rem;
    font-weight: bold;
  }
}
.DockingList {
  margin-top: 2.375rem;
  /* margin-left: 2.125rem; */
  /* margin-right: 2.375rem; */
  font-size: 1rem;
  /* 分割线 */
  /deep/.el-divider--horizontal {
    margin-top: 0;
    margin-left: 4.1875rem;
    width: 92%;
    margin-bottom: 1.3125rem;
  }
  .lis {
    display: flex;
    /* height: 5.0625rem; */
    justify-content: space-between;
    .RightTime {
      margin-top: 1.5625rem;
      color: #999999;
    }
  }

  .LeftInfo {
    display: flex;
    color: #666666;
    img {
      width: 3.625rem;
      height: 3.625rem;
      vertical-align: middle;
      margin-right: 1rem;
    }
    .Left-R {
      text-align: left;
      .pname {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        /* line-height: 24px; */
        color: #333333;
      }
      .p-border {
        width: 50.3125rem;
        margin-top: 0.5rem;
        padding-bottom: 1.5625rem;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        /* line-height: 21px; */
        color: #666666;
      }
    }
  }
}
.commentName {
  color: #2a3457;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.commentTime {
  margin-top: 0.5rem;
}
.commentText {
  color: #9fa3b3;
}
.commentList {
  width: 72.625rem;
  margin: 0 auto;
  text-align: left;
  li {
    background: rgba(249, 249, 249, 0.39);
    margin-bottom: 1.25rem;
  }
}
.islike {
  display: flex;
  margin-left: 4.55rem;
  margin-bottom: 1.25rem;
  .goodjob {
    img {
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
  .comment {
    margin-right: 21px;
    img {
      vertical-align: middle;
      width: 14px;
      margin-right: 5px;
    }
  }
}
.qrcodeBox {
  width: 13.75rem;
  height: 18.25rem;
  margin-top: 0.625rem;

  #qrcode {
    margin-bottom: 1.125rem;
    margin-left: 0.625rem !important;
  }
  p {
    text-align: center;
    color: #999999;
  }
}
</style>
<style lang="scss">
.messageBox {
  justify-content: center;
  font-size: 1.125rem;
  opacity: 0.8;
  top: 28.375rem !important;
  border: 1px solid #707070;
  border-radius: 16px !important;
  background: #333333 !important;
  min-width: 13.75rem !important;
  height: 5rem !important;
  color: #ffffff;
  .el-message__content {
    text-align: center;
    font-size: 1.125rem;
  }
}
</style>
